var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-between h-16 text-black select-none"},[_c('HeaderNavLink',{staticClass:"h-full font-bold text-lg flex items-center px-8 flex-grow no-underline hover-opacity",attrs:{"url":_vm.item.url}},[_vm._v("\n        "+_vm._s(_vm.item.label)+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }